<app-loader *ngIf="isLoading" [loadingMessage]="'Please wait while we retrieve this study...'"></app-loader>